export default "__VITE_ASSET__QXdar0$V__"